import { CartRow } from '../types';

export const cartLoadedReducer = (_, payload: CartRow[]): CartRow[] => {
  return payload;
};
